import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'
import { useMediaQuery } from 'usehooks-ts'

import { DeliveryView, PickupView, useAddressStore } from '@features/shipping-methods'

import TabsSwitcher from './TabsSwitcher'

import styles from './styles.module.scss'

export const condition = {
  DELIVERY: 'delivery',
  PICKUP: 'pickup',
} as const

type ConditionValues = (typeof condition)[keyof typeof condition];

export default function ModalDelivery () {
  const [ conditionState, setConditionState ] =
    useState<ConditionValues>('delivery')
  const { t } = useTranslation('modalDelivery')
  const isDesktop = useMediaQuery('(min-width: 1280px)')
  const { t: tc } = useTranslation('common')
  const { hasHydrated } = useAddressStore()

  const [ headerConfig, setHeaderConfig ] = useState<{
    title: string;
    icon?: boolean;
    onClick?: () => void;
    isTabs?: boolean;
      }>({
        title: t('address'),
        isTabs: true,
      })

  useEffect(() => {
    setHeaderConfig({
      title: t('address'),
      isTabs: true,
    })
  }, [])

  if (!hasHydrated) {
    return null
  }
  return (
    <div className={styles.root}>
      <div onClick={headerConfig.onClick} className={styles.root__title}>
        {headerConfig.icon && (
          <ReactSVG src="/icons/back-arrows.svg" wrapper="span" />
        )}
        <h3>{headerConfig.title}</h3>
      </div>
      {headerConfig.isTabs ? (
        <TabsSwitcher
          className={styles.root__tabs}
          tabs={[
            { label: tc('delivery'), value: 'delivery', icon: 'delivery' },
            { label: tc('pickup'), value: 'pickup', icon: 'pickup' },
          ]}
          active={conditionState}
          onChange={(value) => setConditionState(value as ConditionValues)}
        />
      ) : null}

      {conditionState === 'delivery' ? (
        <DeliveryView setHeaderConfig={setHeaderConfig} isDesktop={isDesktop} />
      ) : (
        <PickupView setHeaderConfig={setHeaderConfig} />
      )}
    </div>
  )
}
